module.exports = "# Ideation\n\nxx\nx\nx\nx\nx\nxx\n"